var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50296 3.14008C9.32367 2.08216 11.5616 2.10066 13.3653 3.18851C15.1512 4.29853 16.2366 6.27958 16.2265 8.41064C16.1849 10.5277 15.021 12.5178 13.5662 14.0562C12.7265 14.9481 11.7871 15.7368 10.7673 16.4061C10.6623 16.4669 10.5472 16.5075 10.4278 16.5261C10.3129 16.5212 10.201 16.4873 10.1022 16.4273C8.54529 15.4216 7.17938 14.1378 6.07021 12.6377C5.14209 11.3856 4.6148 9.87278 4.55994 8.30479C4.55873 6.16964 5.68224 4.19799 7.50296 3.14008ZM8.55507 9.18838C8.86134 9.94342 9.58425 10.4359 10.3863 10.4359C10.9117 10.4397 11.4168 10.2293 11.7889 9.85146C12.1611 9.47367 12.3695 8.95993 12.3676 8.42471C12.3704 7.60776 11.8895 6.86966 11.1493 6.55504C10.4092 6.24042 9.5558 6.41135 8.9877 6.98802C8.41959 7.56468 8.2488 8.43333 8.55507 9.18838Z",
    fill: "#5669FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.3932 19.0261C12.6944 19.0261 14.5599 18.653 14.5599 18.1928C14.5599 17.7325 12.6944 17.3594 10.3932 17.3594C8.09204 17.3594 6.22656 17.7325 6.22656 18.1928C6.22656 18.653 8.09204 19.0261 10.3932 19.0261Z",
    fill: "#5669FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.d75c7706ed724c43203b922e0780433e.svg";
export { ForwardRef as ReactComponent };